import type { DeploymentConfig } from "./types";

/**
 * Default deployment framework configuration.
 *
 * Override values here or merge at integration time — no core logic changes required
 * when pointing at a different check URL or tuning poll intervals.
 */
export const deploymentConfig: DeploymentConfig = {
  enabled: true,

  /** Nginx serves index.html at "/" with no-store and ETag headers. */
  checkUrl: "/",

  /** 10 minutes — only while the tab is visible. */
  pollIntervalMs: 10 * 60 * 1000,

  countdownSeconds: 3,

  /** Skip probes if one ran within the last 30 seconds. */
  minimumCheckGapMs: 30 * 1000,

  /** Wait 1 s after the last route change before probing. */
  routeCheckDebounceMs: 1000,

  /** Spread poll timing by 0–30 s to avoid synchronized client spikes. */
  randomPollJitterMs: 30 * 1000,

  enableVisibilityCheck: true,
  enableRouteChangeCheck: true,

  overlay: {
    title: "New version available",
    message: "Updating application...",
    countdownLabel: "Refreshing in",
    updateNowLabel: "Update now",
  },

  // syncAdapter: createBroadcastChannelSyncAdapter() — wire when multi-tab is needed.
};
